import React from 'react'
import axios from 'axios'

class Home extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			message: {
				status: null,
				message: null
			}
		}
	}

	publish(){
		axios({
			method: 'POST',
			url: 'https://dhsetheatre-api.madebypeppernet.com/api-publish.php',
			headers: { 'Content-type': 'application/x-www-form-urlencoded' }
		}).then( (response) => {
			if(response && response.data && response.data.Status === 'Success'){
				this.setState({
					message: {
						status: 'Success',
						content: 'Site data published'
					}
				})
			} else {
				this.setState({
					message: 'Oops',
					content: 'There was an error.  Please try again.  If it continues to happen, please contact the site administrator.'
				})
			}
		})
	}

	render() {
		return (
			<div className="container publish_container">
				<h2>DHSE Theatre - Admin</h2>
				<h3>Welcome!</h3>
				<p>
					Use the navigation above to update content on the main site.  When editing here, you'll be saving the site content in a "preview"
					state.  When all of the changes are completed, come back here to publish (which will transfer the updates to the live site).
				</p>
				<button className="publish" onClick={this.publish.bind(this)}>Publish Latest</button>

				{ this.state.message.content ?
					<span className="message" data-state={this.state.message.status}><strong>{this.state.message.status}!</strong>{this.state.message.content}</span> :
					null
				}
			</div>
		)
	}
}

export default Home



// WEBPACK FOOTER //
// ./src/pages/home.js